import './VideoContainer.scss';
import { ReactElement } from 'react';
import { Spinner } from '../Spinner';
import { Video } from '../Video';
import { VideoInfo } from './videoTutorialUtils';

interface VideoContainerProps {
  videoContent: VideoInfo | undefined;
}

export const VideoContainer = ({ videoContent }: VideoContainerProps): ReactElement => {
  if (videoContent?.videoFile) {
    return (
      <div className='video-container'>
        <div className='video-content-container'>
          <div className='video-container-header'>{videoContent.title}</div>
          {videoContent.content ? (
            <h3 className='video-container-text-box'>{videoContent.content}</h3>
          ) : null}
          {videoContent.uploadDate ? (
            <h4 className='video-container-small-text'>{`Uploaded: ${videoContent.uploadDate}`}</h4>
          ) : null}
          {videoContent.videoCreator ? (
            <h4 className='video-container-small-text'>{`Video Creator: ${videoContent.videoCreator}`}</h4>
          ) : null}
          <div className='inner-video-container'>
            <Video
              src={videoContent.videoFile}
              controls
              className='video-specs'
              poster={videoContent.thumbnailFile}
              unloader={<Spinner size={20} />}
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className='video-container'>
      <div className='video-content-container'>
        <div className='video-container-header'>No Content Available</div>{' '}
      </div>
      <div className='innerVideo' />
    </div>
  );
};
